const COMMON_SPECIAL_DESIGNATIONS_MAP = {
  GENERAL: "0",
  FRONT_VIEW: "1",
  REAR_VIEW: "2",
  SALOON: "8",
};

const COMMON_SEAT_TYPES_NAME = {
  GENERAL: "一般席",
  FRONT_VIEW: "前展望席",
  REAR_VIEW: "後展望席",
};

const CAR_SPECIAL_DESIGNATIONS_MAP = {
  A: "A",
  B: "B",
  C: "C",
  D: "D",
  E: "E",
  F: "F",
  G: "G",
  H: "H",
  I: "I",
  J: "J",
};

const CAR_SPECIAL_DESIGNATIONS_LIST = [
  "1",
  "2",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
];

export {
  COMMON_SPECIAL_DESIGNATIONS_MAP,
  COMMON_SEAT_TYPES_NAME,
  CAR_SPECIAL_DESIGNATIONS_MAP,
  CAR_SPECIAL_DESIGNATIONS_LIST,
};
